'use client';

import React, { useEffect, useRef, useState, useCallback } from 'react';
import ArrowUpLineIcon from 'remixicon-react/ArrowUpLineIcon';

interface BackToSectionButtonProps {
    title: string;
}

const BackToSectionButton: React.FC<BackToSectionButtonProps> = ({ title }) => {
    const [isVisible, setIsVisible] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const toggleVisibility = useCallback(() => {
        setIsVisible(window.scrollY > 200);
    }, []);

    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);

        const button = buttonRef.current;
        if (button) {
            button.addEventListener('click', scrollToTop);
        }

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
            if (button) {
                button.removeEventListener('click', scrollToTop);
            }
        };
    }, [toggleVisibility, scrollToTop]);

    return (
        <button
            aria-label='back to top'
            ref={buttonRef}
            className={`${isVisible ? 'lg:right-4 opacity-100' : 'lg:-right-20 opacity-0'} fixed bottom-20 z-30 rounded-full bg-gray-200/50 border-gray-300 backdrop-blur-sm p-2.5 leading-none text-white shadow-md transition-all duration-300 ease-in-out hover:-translate-y-2 dark:bg-white/20 border dark:border-white/10 dark:text-primary max-lg:mx-auto max-lg:left-1/2 max-lg:-translate-x-1/2 max-lg:px-2 py-2 flex gap-2 items-center justify-center text-nowrap`}
        >
            <ArrowUpLineIcon
                size={24}
                className='bg-blue-600 p-1 rounded-full scale-125 dark:text-white'
            />
            <span className='text-xs text-primary dark:text-white mx-2'>{title}</span>
        </button>
    );
};

export default BackToSectionButton;
